
import { toast } from "react-toastify";
import ResponseUtils from "utils/ResponseUtils";

const DEFAULT_MESSAGE_ERROR = "Ocurrió un error inesperado, por favor vuelva a intentar."

const show = ({
    message,
    type
}) => {

    switch (type) {
        case "error":
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });

            break;
        case "warning":
            toast.warn(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });

            break;
        case "success":
            toast.success(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });

            break;

        default:
            toast.info(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            break;
    }
}

const showServerError = (error) =>  {
    let message = "";

    if (error.response) {
      // Error con respuesta del servidor
      message = ResponseUtils.getMessageError(error.response);
      if (!message) {
          message = DEFAULT_MESSAGE_ERROR + ' ' + error;
      }

      show({
          message,
          type:"error"
      })
    } else if (error.request) {
      // Error de red - usar detección inteligente asíncrona
      // Importar dinámicamente para evitar dependencias circulares
      import('./ErrorHandler').then(({ default: ErrorHandler }) => {
        ErrorHandler.handleNetworkError(error);
      }).catch(() => {
        // Fallback si no se puede cargar ErrorHandler
        show({
            message: "Error de conexión: No se pudo conectar al servidor.",
            type:"error"
        })
      });
      return; // Salir temprano porque el manejo es asíncrono
    } else if (error.message) {
      // Error en la configuración de la petición
      if (error.message === "Network Error") {
        // Usar detección inteligente para Network Error también
        import('./ErrorHandler').then(({ default: ErrorHandler }) => {
          ErrorHandler.handleNetworkError(error);
        }).catch(() => {
          show({
              message: "Error de red: No se puede conectar al servidor.",
              type:"error"
          })
        });
        return;
      } else {
        message = "Error: " + error.message;
      }
    } else {
      // Error desconocido
      message = DEFAULT_MESSAGE_ERROR + ' ' + error;
    }

    show({
        message,
        type:"error"
    })
  }

  const showError = (message) => {
      show({
          message,
          type : "error"
      })
  }

export default {
    show,
    showServerError,
    showError
}